<template>
    <div>
        <p v-if="error" class="text-danger">{{ errorMsg }}</p>
        <b-modal
            id="existing-item-modal"
            v-model="modalShowing"
            title="Add Existing Items to Quote Sheet"
            size="lg"
            centered
            body-class="bg-gray-100 min-height-500"
            footer-class="bg-gray-100 justify-content-center border-0"
        >
            <item-list 
                ref="itemList" 
                :include-columns="['name', 'category_name', 'part_number']"
                show-select-column 
                :selected-ids="existingItemIds" 
                @item-selected="emitAddItem" 
                allow-duplicate-select
                no-detail-links
                always-show-footer
            ></item-list>

            <template v-slot:modal-footer="{ ok }">
                <div class="d-flex justify-content-between align-items-center w-100">
                    <div class="w-40 text-left">
                    </div>
                    <div class="w-20 text-center">
                        <b-button block variant="primary" @click="ok()">
                            Done
                        </b-button>
                    </div>
                    <div class="w-40 text-right">
                        <div v-if="parentLoading">
                            <b-spinner small></b-spinner>
                            <span class="ml-2 font-italic text-muted">Loading</span>
                        </div>
                    </div>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import ItemList from '../ItemList';

export default {
    name: 'ItemPickerModal',
    components: {
        ItemList,
    },
    props: {
        existingItemIds: {
            type: Array,
            required: true,
        },
        parentLoading: {  // when parent is loading, use this to control state of buttons, etc.
            type: Boolean,
            default: false,
        },
        allowMultipleAdd: {  // if true, you can add products multiple times
            type: Boolean,
            default: false,
        }
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            modalShowing: false,  // v-model to show/hide modal
            loading: false,
        }
    },
    computed: {

    },
    methods: {
        // PUBLIC METHODS: -- call these from parent using $refs
        showModal: function() {
            // show the main modal 
            this.modalShowing = true;
        },
        handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = message;
            this.error = true;
        },
        emitAddItem: function(itemObj) {
            // emit 'add-item' event to parent to add item, pass full item object
            this.$emit('add-item', itemObj);
            // parent should then do something with it, and make sure to add its ID to existingItemIds prop on this component
        },
        alreadyAdded: function(productId) {
            // return Boolean basd on whether this productId is already added (in list in props)
            return this.existingItemIds.includes(productId);
        }
    }
}
</script>

<style>

</style>